import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
} from "@mui/material";
import TeeSelector from "./TeeSelector";

const ScorecardOptions = ({
  numHoles,
  setNumHoles,
  nineChoice,
  setNineChoice,
  teeOptions,
  selectedTee,
  setSelectedTee,
}) => {
  return (
    <>
    <Paper elevation={3} sx={{ p: 2, mb: 4 }}>
      <FormControl component="fieldset" sx={{ mt: 2 }}>
        <FormLabel component="legend">Number of Holes Played</FormLabel>
        <RadioGroup
          row
          value={numHoles}
          onChange={(e) => setNumHoles(e.target.value)}
        >
          <FormControlLabel value="18" control={<Radio />} label="18 Holes" />
          <FormControlLabel value="9" control={<Radio />} label="9 Holes" />
        </RadioGroup>
      </FormControl>

      {numHoles === "9" && (
        <FormControl component="fieldset" sx={{ mt: 2 }}>
          <FormLabel component="legend">
            Which 9 Holes Did You Play?
          </FormLabel>
          <RadioGroup
            row
            value={nineChoice}
            onChange={(e) => setNineChoice(e.target.value)}
          >
            <FormControlLabel
              value="Front"
              control={<Radio />}
              label="Front (1-9)"
            />
            <FormControlLabel
              value="Back"
              control={<Radio />}
              label="Back (10-18)"
            />
          </RadioGroup>
        </FormControl>
      )}

      {teeOptions && teeOptions.length > 0 && (
        <TeeSelector
          teeOptions={teeOptions}
          selectedTee={selectedTee}
          setSelectedTee={setSelectedTee}
        />
      )}
    </Paper>
    </>
  );
};

export default ScorecardOptions;